import { inject, Injectable } from '@angular/core';
import { hasSystemLevelPermission } from '../../../core/services/system-level-permission.util';
import { UtilityService } from '../../../shared/services/utility.service';
import type { Module } from '../modules/modules.model';

@Injectable({
  providedIn: 'root',
})
export class UserRolesService {
  utilityService = inject(UtilityService);

  defaultOptions = [
    { label: 'Inzien (system)', value: 'read', group: 'Systeem' },
    { label: 'Bewerken (system)', value: 'write', group: 'Systeem' },
    { label: 'Aanmaken (system)', value: 'create', group: 'Systeem' },
    { label: 'Inzien (bedrijf)', value: 'company.read', group: 'Bedrijf/vestiging' },
    { label: 'Bewerken (bedrijf)', value: 'company.write', group: 'Bedrijf/vestiging' },
    { label: 'Aanmaken (bedrijf)', value: 'company.create', group: 'Bedrijf/vestiging' },
    { label: 'Inzien (gebruiker)', value: 'employee.read', group: 'Gebruiker' },
    { label: 'Bewerken (gebruiker)', value: 'employee.write', group: 'Gebruiker' },
    { label: 'Aanmaken (gebruiker)', value: 'employee.create', group: 'Gebruiker' },
    { label: 'Niet tonen in menu', value: 'hide', group: 'Algemeen' },
  ];

  /**
   * Permanent delete of archived entries, per scope, row by row and in bulk. Offered on every module of
   * an archive type (`offersPermanentDelete`: modules, entities and pages, the planning modules
   * included — not forms or widgets), by type and not by whether the module keeps entries: a page
   * without any, such as Dashboard, offers it as well. Archiving stays under Bewerken.
   */
  deleteOptions = [
    { label: 'Verwijderen (system)', value: 'delete', group: 'Systeem' },
    { label: 'Verwijderen (bedrijf)', value: 'company.delete', group: 'Bedrijf/vestiging' },
    { label: 'Verwijderen (gebruiker)', value: 'employee.delete', group: 'Gebruiker' },
  ];

  /** Stored as `module.{id}.{permission}` rather than as the bare custom-permission string. */
  isModuleScopedPermission(permission: string): boolean {
    return [...this.defaultOptions, ...this.deleteOptions].some(option => option.value === permission);
  }

  customPermissions: Record<string, { value: string; label: string }[]> = {
    orders: [{ value: 'liveplanning.write', label: 'Live planning bewerken (sync, valideren, publisceren, merge)' }],
    'recurring-order': [
      { value: 'recurringplanning.read', label: 'Terugkerende planning inzien' },
      { value: 'recurringplanning.write', label: 'Terugkerende planning bewerken (sync, split, merge, assign)' },
    ],
  };

  // authorizationService = inject(AuthorizationService);

  // userRoleAdded$ = this.add$.pipe(
  //   concatMap(item =>
  //     this.authorizationService.createRole({ body: item }).pipe(
  //       catchError(err => this.handleError(err)),
  //       map(() => item)
  //     )
  //   ),
  //   share()
  // );
  //
  // userRoleDeleted$ = this.delete$.pipe(
  //   mergeMap(id =>
  //     this.authorizationService.deleteRole({ roleId: id }).pipe(
  //       catchError(err => this.handleError(err)),
  //       map(() => id)
  //     )
  //   ),
  //   share()
  // );
  //
  // userRoleEdited$ = this.edit$.pipe(
  //   mergeMap(update =>
  //     this.authorizationService
  //       .updateRole({ roleId: update.id, body: update.data })
  //       .pipe(
  //         catchError(err => this.handleError(err)),
  //         map(() => update)
  //       )
  //   ),
  //   share()
  // );

  // constructor() {
  //   // reducers
  //   const nextState$ = merge(
  //     this.search$.pipe(map(search => ({ searchTerm: search })))
  //   );
  //
  //   connect(this.state)
  //     .with(nextState$)
  //     .with(this.loaded$, (state, userRoles) => ({
  //       userRoles: userRoles,
  //       loaded: true,
  //     }))
  //     .with(this.userRoleAdded$, (state, item) => ({
  //       userRoles: [...state.userRoles, { ...item, id: Date.now().toString() }],
  //     }))
  //     .with(this.userRoleDeleted$, (state, id) => ({
  //       userRoles: UtilityService.deleteIdFromArray(state.userRoles, id),
  //     }))
  //     .with(this.userRoleEdited$, (state, update) => ({
  //       userRoles: state.userRoles.map(item =>
  //         item.id === update.id
  //           ? {
  //               ...item,
  //               ...(update.data as RoleResponse),
  //             }
  //           : item
  //       ),
  //     }))
  //     .with(
  //       merge(
  //         this.userRoleAdded$,
  //         this.userRoleDeleted$,
  //         this.userRoleEdited$
  //       ).pipe(
  //         switchMap(value => {
  //           return this.authorizationService.getRoles();
  //         })
  //       ),
  //       (state, userRoles) => ({
  //         ...state,
  //         userRoles: userRoles,
  //         loaded: true,
  //       })
  //     );
  //
  //   this.utilityService.notify(this.userRoleAdded$, 'Gebruikersrol aangemaakt');
  //   this.utilityService.notify(
  //     this.userRoleEdited$,
  //     'Gebruikersrol opgeslagen'
  //   );
  //   this.utilityService.notify(
  //     this.userRoleDeleted$,
  //     'Gebruikersrol verwijderd'
  //   );
  // }

  // private handleError(err: any) {
  //   this.state.update(state => ({ ...state, error: err }));
  //   return EMPTY;
  // }

  getDefaultUserRole(modules: Module[]) {
    const defaultUserRole = {
      id: '',
      name: '',
      permissions: [],
    };

    const defaultModuleCodes = ['profile', 'company-settings', 'usersettings'];

    modules.forEach(module => {
      if (defaultModuleCodes.includes(module.code)) {
        defaultUserRole.permissions.push(module.id + '.read');
        defaultUserRole.permissions.push(module.id + '.write');
        defaultUserRole.permissions.push(module.id + '.hide');
      }
    });
    return defaultUserRole;
  }

  checkIfHasViewPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.read'));
  }

  checkIfHasEditPermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.write'));
  }

  checkIfHasCreatePermission(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.create'));
  }

  checkHideModuleInMenu(permissions: Array<string>, moduleId: string) {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes('.hide'));
  }

  // The system-level boxes of the role editor share one reading (`hasSystemLevelPermission`).
  checkIfHasSystemViewPermission(permissions: Array<string>, moduleId: string) {
    return hasSystemLevelPermission(permissions, moduleId, 'read');
  }

  checkIfHasSystemEditPermission(permissions: Array<string>, moduleId: string) {
    return hasSystemLevelPermission(permissions, moduleId, 'write');
  }

  checkIfHasSystemCreatePermission(permissions: Array<string>, moduleId: string) {
    return hasSystemLevelPermission(permissions, moduleId, 'create');
  }

  checkIfHasSystemDeletePermission(permissions: Array<string>, moduleId: string) {
    return hasSystemLevelPermission(permissions, moduleId, 'delete');
  }

  checkIfHasCompanyViewPermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'company', 'read');
  }

  checkIfHasCompanyEditPermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'company', 'write');
  }

  checkIfHasCompanyCreatePermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'company', 'create');
  }

  checkIfHasCompanyDeletePermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'company', 'delete');
  }

  checkIfHasEmployeeViewPermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'employee', 'read');
  }

  checkIfHasEmployeeEditPermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'employee', 'write');
  }

  checkIfHasEmployeeCreatePermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'employee', 'create');
  }

  checkIfHasEmployeeDeletePermission(permissions: Array<string>, moduleId: string) {
    return this.#hasScopedPermission(permissions, moduleId, 'employee', 'delete');
  }

  /**
   * Whether a stored permission grants `action` on the module in the company or employee scope: it
   * contains `{scope}.{action}`. Matched by substring, as these checks always have. The system level
   * goes through `hasSystemLevelPermission`.
   */
  #hasScopedPermission(
    permissions: Array<string>,
    moduleId: string,
    scope: 'company' | 'employee',
    action: 'read' | 'write' | 'create' | 'delete'
  ): boolean {
    if (permissions === undefined) {
      return false;
    }

    return permissions.some(permission => permission.includes(moduleId) && permission.includes(`${scope}.${action}`));
  }
}
